import {RouteRecordRaw} from "vue-router";
import {t} from "@/core/i18n";


export const routes: RouteRecordRaw = {
    path: "/monitoring",
    name: "monitoring",
    redirect: {name: "usersNoLogins"},
    children: [
        {
            path: "/monitoring/usersNoLogins",
            name: "usersNoLogins",
            component: () => import("@/modules/Monitoring/pages/UsersNoLogins.vue"),
            meta: {
                breadcrumb: [
                    {title: t("monitoring"), routeName: "monitoring"},
                    {title: t("usersNoLogins"), routeName: "usersNoLogins"},
                ],
            },
        },
        {
            path: "/monitoring/usersNeverLogins",
            name: "usersNeverLogins",
            component: () => import("@/modules/Monitoring/pages/UsersNeverLogins.vue"),
            meta: {
                breadcrumb: [
                    {title: t("monitoring"), routeName: "monitoring"},
                    {title: t("usersNeverLogins"), routeName: "usersNeverLogins"},
                ],
            },
        },
        {
            path: "/monitoring/lessonDownloads",
            name: "lessonDownloads",
            component: () => import("@/modules/Monitoring/pages/lessonDownloads.vue"),
            meta: {
                breadcrumb: [
                    {title: t("monitoring"), routeName: "monitoring"},
                    {title: t("lessonDownloads"), routeName: "lessonDownloads"},
                ],
            },
        },
        {
            path: "/monitoring/testimonials",
            name: "testimonials",
            component: () => import("@/modules/Monitoring/pages/Testimonials.vue"),
            meta: {
                breadcrumb: [
                    {title: t("monitoring"), routeName: "monitoring"},
                    {title: t("testimonials"), routeName: "testimonials"},
                ],
            },
        },
    ]

}